import { FC } from "react"
import { ApplicationReview } from "../../../../core/applications"


type Props = {
  review: ApplicationReview  
}

export const ApplicationReviewApplicantActionsCell: FC<Readonly<Props>> = ({review}) => {
    
  return (
  <div className="d-flex justify-content-end gap-2">
    
  </div>
  )
}
